import sha256 from "tiny-sha256";
import { createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
export const persistedQueriesLink = () => {
    return createPersistedQueryLink({
        sha256,
        useGETForHashedQueries: true,
    });
};
//# sourceMappingURL=persisted-queries-link.js.map